import $ from 'expose-loader?exposes=$,jQuery!jquery'

export function switchDepartment(items) {
  $('.deptsdesc').children().hide()
  $('.dept_' + items).show()
  $('.dptpriority').hide().find('select').attr('disabled', 'disabled')
  $('#p' + items).show().find('select').removeAttr('disabled')
}
